import { useI18n } from 'vue-i18n'
import {
  ACTION_APPROVE,
  ACTION_AUTO_APPROVE,
  ACTION_REJECT,
  type ApprovalHistoryTrace
} from '@/api/approval'

/**
 * 审批轨迹展示辅助（节点名、操作名、驳回原因等）
 */
export function useApprovalTraceDisplay() {
  const { t } = useI18n()

  const toApprovalText = (value: unknown) => {
    if (value === null || value === undefined || value === '') {
      return '-'
    }
    return String(value)
  }

  const getApprovalTraceNodeName = (trace: ApprovalHistoryTrace) => {
    return trace.processNode?.name
      || `${t('home.approval.history.node')} ${toApprovalText(trace.processNodeId || trace.documentProcessNodeId)}`
  }

  /** 展示文案：已知 actionType 走前端 i18n；其余以后端 actionName 为准 */
  const getApprovalTraceActionLabel = (trace: ApprovalHistoryTrace) => {
    const actionType = Number(trace.actionType)
    if (actionType === ACTION_APPROVE || actionType === ACTION_AUTO_APPROVE) {
      return t('home.approval.batch.approve')
    }
    if (actionType === ACTION_REJECT) {
      return t('home.approval.batch.reject')
    }
    const rawName = String(trace.actionName || '').trim()
    if (rawName) {
      return trace.actionName as string
    }
    return toApprovalText(trace.actionType)
  }

  const sortApprovalTraces = (traces: ApprovalHistoryTrace[]) => {
    return [...traces].sort((left, right) => {
      const leftTime = new Date(String(left.createTime || left.lastModified || 0)).getTime()
      const rightTime = new Date(String(right.createTime || right.lastModified || 0)).getTime()
      return leftTime - rightTime
    })
  }

  const getLatestRejectTrace = (traces: ApprovalHistoryTrace[]) => {
    const rejectTraces = traces.filter(trace => Number(trace.actionType) === ACTION_REJECT)
    return rejectTraces.length > 0 ? rejectTraces[rejectTraces.length - 1] : null
  }

  return {
    toApprovalText,
    getApprovalTraceNodeName,
    getApprovalTraceActionLabel,
    sortApprovalTraces,
    getLatestRejectTrace
  }
}
